import React, { Component } from 'react';
import { Button, Row, Col, Card, CardHeader, CardTitle, CardBody, Table,
  Nav, NavItem, NavLink, TabContent, TabPane, ButtonGroup
} from 'reactstrap';
import numberWithCommas from "../constant/numberFormat.js";
import classNames from "classnames";
import r2h_logo from "assets/img/R2H_logo_1117_02_outline-15.png";
import oa_logo from "assets/img/OceanAtlas_logo.png";
import TinyLoading from "components/tiny/TinyLoading";

const EnhancedNav = ({ children, ...props }) => {
  return (
    <Nav 
      {...props} 
      className="custom-nav mb-1 position-relative"
      style={{
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        display: 'flex',
        flexWrap: 'wrap',
        background: '#111822',
        padding: '4px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        cursor: "pointer"
      }}
    >
      {children}
    </Nav>
  );
};

const EnhancedNavItem = ({ children, ...props }) => {
  return (
    <NavItem 
      {...props} 
      style={{
        margin: '2px',
        position: 'relative',
        zIndex: 1
      }}
    >
      {children}
    </NavItem>
  );
};

const EnhancedNavLink = ({ children, active, onClick, ...props }) => {
  return (
    <NavLink
      {...props}
      active={active}
      onClick={onClick}
      className={classNames({ active: active })}
      style={{
        padding: '10px 18px',
        borderRadius: '6px',
        fontSize: '14px',
        fontWeight: active ? '600' : '400',
        transition: 'all 0.2s ease',
        color: active ? '#fff' : 'rgba(255, 255, 255, 0.7)',
        background: active ? 'linear-gradient(135deg, #005580, #007399)' : 'transparent',
        border: active ? 'none' : '1px solid transparent',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '100px',
        textAlign: 'center',
        boxShadow: active ? '0 3px 8px rgba(0, 103, 255, 0.3)' : 'none'
      }}
    >
      {children}
    </NavLink>
  );
};

class OAFeeDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      activeUnionFeeTab: 0,
      activeClubFeeTab: 0,
      activeGamesFeeTab: 0,
      activeUnionMembershipTab: 0,
      activeMembershipTab: 0,
      activeProvider: 'OceanAtlas',
      membershipView: 'card',
      timeIntervalUnionFee: 'allTime',
      timeIntervalClubFee: 'allTime',
      timeIntervalGamesFee: 'allTime',
      timeIntervalMembership: 'allTime',
      viewModeUnionFee: 'table',
      viewModeClubFee: 'table',
      viewModeGamesFee: 'table',
      viewModeUnionMembership: 'table',
      mainClubSortCriteria: 'last10weeks',
    };
  }

  componentDidMount() {
    // 預設載入第一個 tab 的資料
    if (this.props.getUnionsFee) {
      this.props.getUnionsFee();
    }
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  toggleProvider = (provider) => {
    this.setState({ activeProvider: provider });
  }

  // 簡化的 Union Fee 表格
  renderUnionFeeTable = () => {
    const { unions_fee = [], unions_col = [] } = this.props;
    const cellCentered = { textAlign: 'center' };

    if (!unions_fee || unions_fee.length === 0) {
      return <TinyLoading variant="block" text="載入中" />;
    }

    return (
      <div className="table-responsive">
        <Table className="tablesorter">
          <thead className="text-primary">
            <tr>
              <th style={cellCentered}>聯盟</th>
              {unions_col.slice(0, 10).map((col, idx) => (
                <th key={idx} style={cellCentered}>
                  {typeof col === 'object' ? col.name : col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {unions_fee.map((row, idx) => (
              <tr key={idx}>
                <td style={cellCentered}>
                  {typeof (row.union_name || row.name) === 'object' 
                    ? (row.union_name?.name || row.name?.name || JSON.stringify(row.union_name || row.name))
                    : (row.union_name || row.name)}
                </td>
                {unions_col.slice(0, 10).map((col, colIdx) => {
                  const colKey = typeof col === 'object' ? col.id : col;
                  return (
                    <td key={colIdx} style={cellCentered}>
                      {numberWithCommas(Math.round(row[colKey] || 0))}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  // 簡化的 Main Club Fee 表格
  renderMainClubFeeTable = () => {
    const { main_club = {} } = this.props;
    const { clubs = [], sumData = {} } = main_club;
    const cellCentered = { textAlign: 'center' };

    if (!clubs || clubs.length === 0) {
      return <TinyLoading variant="block" text="載入中" />;
    }

    return (
      <div className="table-responsive">
        <Table className="tablesorter">
          <thead className="text-primary">
            <tr>
              <th style={cellCentered}>俱樂部</th>
              <th style={cellCentered}>服務費總計</th>
            </tr>
          </thead>
          <tbody>
            {clubs.map((club, idx) => (
              <tr key={idx}>
                <td style={cellCentered}>
                  {typeof club.name === 'object' ? (club.name?.name || JSON.stringify(club.name)) : club.name}
                </td>
                <td style={cellCentered}>{numberWithCommas(Math.round(club.total || 0))}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  // 簡化的 Games Fee 表格
  renderGamesFeeTable = () => {
    const { games_fee = [], games_col = [] } = this.props;
    const cellCentered = { textAlign: 'center' };

    if (!games_fee || games_fee.length === 0) {
      return <TinyLoading variant="block" text="載入中" />;
    }

    return (
      <div className="table-responsive">
        <Table className="tablesorter">
          <thead className="text-primary">
            <tr>
              <th style={cellCentered}>遊戲類型</th>
              {games_col.slice(0, 10).map((col, idx) => (
                <th key={idx} style={cellCentered}>
                  {typeof col === 'object' ? col.name : col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {games_fee.map((row, idx) => (
              <tr key={idx}>
                <td style={cellCentered}>
                  {typeof (row.game_type || row.name) === 'object'
                    ? (row.game_type?.name || row.name?.name || JSON.stringify(row.game_type || row.name))
                    : (row.game_type || row.name)}
                </td>
                {games_col.slice(0, 10).map((col, colIdx) => {
                  const colKey = typeof col === 'object' ? col.id : col;
                  return (
                    <td key={colIdx} style={cellCentered}>
                      {numberWithCommas(Math.round(row[colKey] || 0))}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  // 簡化的 Membership 表格
  renderMembershipTable = () => {
    const { membership_header = [], membership_sum = [] } = this.props;
    const cellCentered = { textAlign: 'center' };

    if (!membership_sum || membership_sum.length === 0) {
      return <TinyLoading variant="block" text="載入中" />;
    }

    return (
      <div className="table-responsive">
        <Table className="tablesorter">
          <thead className="text-primary">
            <tr>
              <th style={cellCentered}>日期</th>
              {membership_header.map((header, index) => (
                <th key={index} style={cellCentered}>
                  {typeof header === 'object' ? header.name : header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {membership_sum.map((item, idx) => (
              <tr key={idx}>
                <td style={cellCentered}>{item.duration}</td>
                {membership_header.map((header, index2) => {
                  const headerId = typeof header === 'object' ? header.id : header;
                  return (
                    <td key={index2} style={cellCentered}>
                      {numberWithCommas(Math.round(item[headerId] || 0))}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  // 簡化的 Union Membership 表格
  renderUnionMembershipTable = () => {
    const { union_membership_amount = [] } = this.props;
    const cellCentered = { textAlign: 'center' };

    if (!union_membership_amount || union_membership_amount.length === 0) {
      return <TinyLoading variant="block" text="載入中" />;
    }

    return (
      <div className="table-responsive">
        <Table className="tablesorter">
          <thead className="text-primary">
            <tr>
              <th style={cellCentered}>聯盟</th>
              <th style={cellCentered}>VIP 金額</th>
            </tr>
          </thead>
          <tbody>
            {union_membership_amount.map((item, idx) => (
              <tr key={idx}>
                <td style={cellCentered}>
                  {typeof (item.union_name || item.name) === 'object'
                    ? (item.union_name?.name || item.name?.name || JSON.stringify(item.union_name || item.name))
                    : (item.union_name || item.name)}
                </td>
                <td style={cellCentered}>{numberWithCommas(Math.round(item.amount || 0))}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  // MTT 表格（OA）
  renderOAMTTTable = () => {
    const { revenue = [] } = this.props;
    const cellCentered = { textAlign: 'center' };

    return (
      <div className="table-responsive">
        <Table className="tablesorter">
          <thead className="text-primary">
            <tr>
              <th style={cellCentered}>日期</th>
              <th style={cellCentered}>MTT Fee</th>
              <th style={cellCentered}>MTT Overlay</th>
              <th style={cellCentered}>MTT 淨收入</th>
            </tr>
          </thead>
          <tbody>
            {revenue.map((item, idx) => (
              <tr key={idx}>
                <td style={cellCentered}>{item.duration}</td>
                <td style={cellCentered}>{numberWithCommas(Math.round(item.mttFee || 0))}</td>
                <td style={cellCentered}>{numberWithCommas(Math.round(item.mttOverlay || 0))}</td>
                <td style={cellCentered}>{numberWithCommas(Math.round((item.mttFee || 0) - (item.mttOverlay || 0)))}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  render() {
    return (
      <div className="content">
        <Row>
          <Col xs="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  <i className="fa fa-ship mr-2" /> OceanAtlas 費用明細
                </CardTitle>
              </CardHeader>
              <CardBody>
                <EnhancedNav tabs>
                  <EnhancedNavItem>
                    <EnhancedNavLink 
                      active={this.state.activeTab === "1"} 
                      onClick={() => { this.toggleTab('1'); this.props.getUnionsFee && this.props.getUnionsFee(); }}
                    >
                      Fee By Unions
                    </EnhancedNavLink>
                  </EnhancedNavItem>
                  <EnhancedNavItem>
                    <EnhancedNavLink 
                      active={this.state.activeTab === "2"} 
                      onClick={() => { this.toggleTab('2'); this.props.getUnionsFee && this.props.getUnionsFee(); }}
                    >
                      Fee By Main Clubs
                    </EnhancedNavLink>
                  </EnhancedNavItem>
                  <EnhancedNavItem>
                    <EnhancedNavLink 
                      active={this.state.activeTab === "3"} 
                      onClick={() => { this.toggleTab('3'); this.props.getGamesFee && this.props.getGamesFee(); }}
                    >
                      Fee By Games
                    </EnhancedNavLink>
                  </EnhancedNavItem>
                  <EnhancedNavItem>
                    <EnhancedNavLink 
                      active={this.state.activeTab === "4"} 
                      onClick={() => { 
                        this.toggleTab('4'); 
                        this.props.getMembershipData && this.props.getMembershipData(); 
                        this.props.getUnionMembership && this.props.getUnionMembership();
                      }}
                    >
                      Membership
                    </EnhancedNavLink>
                  </EnhancedNavItem>
                  <EnhancedNavItem>
                    <EnhancedNavLink 
                      active={this.state.activeTab === "5"} 
                      onClick={() => { this.toggleTab('5'); this.props.onLoad && this.props.onLoad(); }}
                    >
                      MTT
                    </EnhancedNavLink>
                  </EnhancedNavItem>
                </EnhancedNav>

                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    {this.renderUnionFeeTable()}
                  </TabPane>
                  <TabPane tabId="2">
                    {this.renderMainClubFeeTable()}
                  </TabPane>
                  <TabPane tabId="3">
                    {this.renderGamesFeeTable()}
                  </TabPane>
                  <TabPane tabId="4">
                    <Row>
                      <Col xs="12" className="mb-3">
                        <ButtonGroup>
                          <Button 
                            color="primary" 
                            outline={this.state.membershipView !== 'card'} 
                            onClick={() => this.setState({ membershipView: 'card' })}
                          >
                            賣出VIP種類統計
                          </Button>
                          <Button 
                            color="primary" 
                            outline={this.state.membershipView !== 'union'} 
                            onClick={() => this.setState({ membershipView: 'union' })}
                          >
                            各聯盟VIP統計
                          </Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                    {this.state.membershipView === 'card' ? 
                      this.renderMembershipTable() :
                      this.renderUnionMembershipTable()
                    }
                  </TabPane>
                  <TabPane tabId="5">
                    <Row>
                      <Col xs="12" className="mb-3">
                        <ButtonGroup>
                          <Button 
                            color={this.state.activeProvider === 'OceanAtlas' ? 'info' : 'secondary'}
                            className="d-flex align-items-center"
                            onClick={() => this.toggleProvider('OceanAtlas')}
                          >
                            <img src={oa_logo} alt="OceanAtlas Logo" style={{ height: '20px', marginRight: '8px' }} />
                            OA MTT
                          </Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                    {this.renderOAMTTTable()}
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default OAFeeDetails;


